import React from 'react';
import { Controller } from 'react-hook-form';
import { Col, Input } from 'reactstrap';

function CostField({ service, status, control }) {
  const COST_FIELDS = {
    Flight: 'flightCost',
    Hotel: 'hotelCost',
    Visa: 'visaCost',
    TravelInsurance: 'travelInsuranceCost',
    AirportTransfer: 'airportTransferCost',
  };

  const REBOOK_FIELDS = {
    Flight: 'flightRebookCost',
    Hotel: 'hotelRebookCost',
    Visa: 'visaRebookCost',
    TravelInsurance: 'travelInsuranceRebookCost',
    AirportTransfer: 'airportTransferRebookCost',
  };

  const QUOTE_FIELDS = {
    Flight: 'flightQuoteCost',
    Hotel: 'hotelQuoteCost',
    Visa: 'visaQuoteCost',
    TravelInsurance: 'travelInsuranceQuoteCost',
    AirportTransfer: 'airportTransferQuoteCost',
  };

  const CANCEL_FIELDS = {
    Flight: 'flightCancelRefund',
    Hotel: 'hotelCancelRefund',
    Visa: 'visaCancelRefund',
    TravelInsurance: 'travelCancelInsuranceRefund',
    AirportTransfer: 'airportCancelTransferRefund',
  };

  const fieldFor = (kind = 'auto') => {
    let name;
    let label;

    const serviceLabel = service.replace(/([a-z])([A-Z])/g, '$1 $2');

    if (kind === 'quote') {
      name = QUOTE_FIELDS[service];
      label = `${serviceLabel} Quote Cost`;
    } else if (status === 'Request for Cancellation') {
      name = CANCEL_FIELDS[service];
      label = `${serviceLabel} Refund`;
    } else if (status === 'Request for Rebooking') {
      name = REBOOK_FIELDS[service];
      label = `${serviceLabel} Rebook Cost`;
    } else {
      name = COST_FIELDS[service];
      label = `${serviceLabel} Cost`;
    }

    return { name, label, placeholder: '0' };
  };

  const cfg = fieldFor(service, status);

  return (
    <Col className="external-filter-col">
      <span className="ba-form-label">
        {cfg.label}
        <span className="text-danger">*</span>
      </span>

      <Controller
        control={control}
        name={cfg.name}
        render={({ field, fieldState }) => (
          <>
            <Input
              {...field}
              type="number"
              inputMode="decimal"
              step="any"
              min={0}
              placeholder={cfg.placeholder}
              className={`external-filter-input ${fieldState.error ? 'is-invalid' : ''}`}
              onChange={e => {
                const v = e.target.value;
                field.onChange(v === '' ? undefined : Number(v));
              }}
              onBlur={e => {
                const val = e.target.value;
                field.onChange(val === '' ? '' : parseFloat(val).toFixed(2));
              }}
            />
            {fieldState.error && (
              <span className="text-danger">{fieldState.error.message}</span>
            )}
          </>
        )}
      />
    </Col>
  );
}

export default CostField;
